import classNames from 'classnames';
import { fixedForwardRef } from '~/components/Util/react';
import styles from './Collapse.module.scss';

export type CollapseProps = {
  variant?: 'wipe' | 'grow';
  active?: boolean;
} & JSX.IntrinsicElements['div'];
export const Collapse = fixedForwardRef<HTMLDivElement, CollapseProps>(
  ({ variant = 'wipe', active, className, children, ...props }, ref) => (
    <div
      className={classNames(
        styles.root,
        {
          [styles.active]: active,
        },
        styles[variant],
        className
      )}
      {...props}
      ref={ref}>
      <div className={styles.body}>{children}</div>
    </div>
  )
);
